import type { FC, useEffect } from "react"
import React, { useState } from "react"
import { useTranslation } from "react-i18next"
import { useTheme } from "@mui/material/styles"
import {
  Box,
  Step,
  Stepper,
  IconButton,
  Button,
  ButtonGroup,
  Typography,
  Stack,
} from "../../../components/mui.components"
import { Warning, Info } from "@mui/icons-material"
import { useAppDispatch, useAppSelector } from "@/core/app/hooks"
import { RootState } from "@/core/app/store"
import { ReactSVG } from "react-svg"

import CloseSvg from "../../assets/modeltools/RedXMark.svg"
import ResetSvg from "../../assets/bottomToolBar/stage/reset.svg"

import { resegmentationModule } from "@/gluelayer/core/modules/resegmentation/resegmentationModule"

interface Type {
  ClickSave?: () => void
  ClickReset?: () => void
  ClickClose?: (e) => void
  DoShowClose?: boolean
}

const OrientationTools: FC<Type> = ({
  ClickSave,
  ClickReset,
  ClickClose,
  DoShowClose,
}) => {
  const dispatch = useAppDispatch()
  const theme = useTheme()
  const { curLeftPage } = useAppSelector(
    (state: RootState) => state.udTreatService,
  )
  console.log("curLeftPage-records", curLeftPage)
  return (
    <>
      <Box
        sx={{
          display: "flex",
          alignItems: "flex-end",
          position: "absolute",
          top: curLeftPage === "records" ? "120px" : "250px",
          right: "1%",
          width: "130px",
          height: "500px",
          borderRadius: 2,
          flexDirection: "column",

          //bgcolor: theme.transBkColor.light
        }}
      >
        <Box
          sx={{
            display: "flex",
            right: "2%",
            width: "250px",
            height: "70px",
            borderRadius: 2,
            flexDirection: "row",
            alignItems: "center",
            //bgcolor: theme.transBkColor.light
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "flex-end",
              width: "100%",
              height: "70px",
              borderRadius: 2,
              flexDirection: "column",
              marginRight: "20px",

              //bgcolor: theme.transBkColor.light
            }}
          >
            <Typography variant="h5" color="#FFFFFF">
              Check
            </Typography>
            <Typography variant="h5" color="#FFFFFF">
              Orientation
            </Typography>
          </Box>

          {DoShowClose && (
            <Box
              sx={{
                display: "flex",
                alignItems: "column",
                width: "35px",
                height: "50px",
              }}
            >
              <IconButton
                sx={{
                  display: "flex",
                  alignItems: "center",
                  width: "35px",
                  height: "35px",
                  borderRadius: 100,
                  backgroundColor: "#FF632B",
                  "&:hover": { background: "#FF632B" },
                }}
                onClick={ClickClose}
              >
                <img
                  src={CloseSvg}
                  style={{ height: "18px", width: "18px" }}
                ></img>
              </IconButton>
            </Box>
          )}
        </Box>

        {/* <Box
          sx={{
            display: "flex",
            alignItems: "center",
            marginTop: "15px",
            width: "65px",
            height: "65px",
            // borderRadius: 2,
            flexDirection: "column",
            marginRight: "5px",
            // gap: "29px",
            // paddingTop: "49px",
            backgroundColor: theme.transBkColor.light,
          }}
        >
          {false && (
            <Button
              sx={{
                height: "20px",
                width: "52px",
                textTransform: "none",
                flexWrap: "wrap",
                padding: "0px 0px",
                border: "none",
                borderRadius: "0px",
              }}
              onClick={(e) => {
                if (ClickSave) ClickSave()
              }}
            >
              <Typography
                fontSize="14px"
                fontWeight="600"
                fontFamily="Roboto"
                fontStyle="normal"
                color="#444444"
                letterSpacing="0.1px"
              >
                Save
              </Typography>
            </Button>
          )}

          <Button
            sx={{
              height: "65px",
              width: "65px",
              textTransform: "none",
              padding: "0px 0px",
              flexWrap: "wrap",
              border: "none",
              borderRadius: "0px",
            }}
            onClick={(e) => {
              if (ClickReset) ClickReset()
            }}
          >
            <Typography
              fontSize="14px"
              fontWeight="600"
              fontFamily="Roboto"
              fontStyle="normal"
              color="#444444"
              letterSpacing="0.1px"
            >
              Reset
            </Typography>
          </Button>
        </Box> */}
      </Box>
    </>
  )
}
export default OrientationTools
